import { render, staticRenderFns } from "./RelatedList.vue?vue&type=template&id=4a3d441f&scoped=true&"
import script from "./RelatedList.vue?vue&type=script&lang=js&"
export * from "./RelatedList.vue?vue&type=script&lang=js&"
import style0 from "./RelatedList.vue?vue&type=style&index=0&id=4a3d441f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3d441f",
  null
  
)

export default component.exports